module.exports = __webpack_public_path__ + "img/Conlan.83f53c49.jpeg";